// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 502 ? "GalleryImageElement" : chunkId) + "." + {"3":"532609df55b1bb00","502":"52786b492fb34a42"}[chunkId] + ".js";
};